module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUyNiA3NzAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+UHJhbmNoZXRhIDE2PC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMS44MSw0OTguNTVoMjMxLjRWMjcxLjg4SDIxLjgxWm0wLDI1MC42NmgyMzEuNFY1MTguMDhIMjEuODFabTI1MS0yNTAuNjZINDMyLjQ1YzM5LjYyLDAsNzEuNzMtMzEuNDgsNzEuNzMtNzAuM1YyNzEuODhIMjcyLjc5Wk0yMS44MSwyNTIuM2gyMzEuNFYyMC43OEgyMS44MVpNNDMyLjE5LDIwLjc4SDI3Mi43OVYyNTIuM2gyMzEuNFY5Mi43OEE3Miw3MiwwLDAsMCw0MzIuMTksMjAuNzhaIi8+PC9zdmc+"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/pickly-white.svg
 ** module id = 464
 ** module chunks = 0
 **/